import { t } from "i18next";
import Theme from "../../../../styles/Theme/Theme";

export const occupationDA = {
    "totalReservations": {
        "number": 137,
        "unit": "(69%)",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "checkinsDone": {
        "number": 102,
        "unit": "",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "checkoutsMissing": {
        "number": 0,
        "unit": "",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "realOccupationTop": {
        "number": 144,
        "unit": "",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "distributionPeopleFloor": {
        "series": [
            {
                "name": "Real",
                "data": [
                    {
                        "x": "Piso 1",
                        "y": 8
                    },
                    {
                        "x": "Piso 2",
                        "y": 22
                    },
                    {
                        "x": "Piso 3",
                        "y": 32
                    },
                    {
                        "x": "Piso 4",
                        "y": 40
                    },
                    {
                        "x": "Piso 5",
                        "y": 15
                    },
                    {
                        "x": "Piso 6",
                        "y": 27
                    }
                ]
            },
            {
                "name": "Reservas",
                "data": [
                    {
                        "x": "Piso 1",
                        "y": 7
                    },
                    {
                        "x": "Piso 2",
                        "y": 24
                    },
                    {
                        "x": "Piso 3",
                        "y": 32
                    },
                    {
                        "x": "Piso 4",
                        "y": 34
                    },
                    {
                        "x": "Piso 5",
                        "y": 9
                    },
                    {
                        "x": "Piso 6",
                        "y": 20
                    }
                ]
            }
        ],
        "categories": [],
        // "xAxisType": "",
        "labelFormat": "",
        "tooltip": null,
        "unit": "",
        "columnWidth": 10,
        "xAxisLabel": null,
        "yAxisLabel": "",
        "color": null,
        "formatterType": null,
        // "tickAmount": 1,
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "showTooltipTitle": false,
        "strokeWidth": 2,
        // "xaxisLabelHide": true
    },
    "distributionThroughoutDay": {
        "series": [
            {
                "name": "Check-In",
                "data": [
                    {
                        "x": "00:00",
                        "y": 2
                    },
                    {
                        "x": "01:00",
                        "y": 2
                    },
                    {
                        "x": "02:00",
                        "y": 2
                    },
                    {
                        "x": "03:00",
                        "y": 2
                    },
                    {
                        "x": "04:00",
                        "y": 2
                    },
                    {
                        "x": "05:00",
                        "y": 2
                    },
                    {
                        "x": "06:00",
                        "y": 2
                    },
                    {
                        "x": "07:00",
                        "y": 2
                    },
                    {
                        "x": "08:00",
                        "y": 3
                    },
                    {
                        "x": "09:00",
                        "y": 3
                    },
                    {
                        "x": "10:00",
                        "y": 4
                    },
                    {
                        "x": "11:00",
                        "y": 5
                    },
                    {
                        "x": "12:00",
                        "y": 3
                    },
                    {
                        "x": "13:00",
                        "y": 1
                    },
                    {
                        "x": "14:00",
                        "y": 0
                    },
                    {
                        "x": "15:00",
                        "y": 2
                    },
                    {
                        "x": "16:00",
                        "y": 3
                    },
                    {
                        "x": "17:00",
                        "y": 4
                    },
                    {
                        "x": "18:00",
                        "y": 6
                    },
                    {
                        "x": "19:00",
                        "y": 6
                    },
                    {
                        "x": "20:00",
                        "y": 6
                    },
                    {
                        "x": "21:00",
                        "y": 6
                    },
                    {
                        "x": "22:00",
                        "y": 6
                    },
                    {
                        "x": "23:00",
                        "y": 6
                    }
                ]
            },
            {
                "name": t("Occupation"),
                "data": [
                    {
                        "x": "00:00",
                        "y": 2
                    },
                    {
                        "x": "01:00",
                        "y": 2
                    },
                    {
                        "x": "02:00",
                        "y": 2
                    },
                    {
                        "x": "03:00",
                        "y": 2
                    },
                    {
                        "x": "04:00",
                        "y": 2
                    },
                    {
                        "x": "05:00",
                        "y": 2
                    },
                    {
                        "x": "06:00",
                        "y": 2
                    },
                    {
                        "x": "07:00",
                        "y": 2
                    },
                    {
                        "x": "08:00",
                        "y": 3
                    },
                    {
                        "x": "09:00",
                        "y": 3
                    },
                    {
                        "x": "10:00",
                        "y": 4
                    },
                    {
                        "x": "11:00",
                        "y": 5
                    },
                    {
                        "x": "12:00",
                        "y": 3
                    },
                    {
                        "x": "13:00",
                        "y": 1
                    },
                    {
                        "x": "14:00",
                        "y": 0
                    },
                    {
                        "x": "15:00",
                        "y": 2
                    },
                    {
                        "x": "16:00",
                        "y": 3
                    },
                    {
                        "x": "17:00",
                        "y": 4
                    },
                    {
                        "x": "18:00",
                        "y": 6
                    },
                    {
                        "x": "19:00",
                        "y": 6
                    },
                    {
                        "x": "20:00",
                        "y": 6
                    },
                    {
                        "x": "21:00",
                        "y": 6
                    },
                    {
                        "x": "22:00",
                        "y": 6
                    },
                    {
                        "x": "23:00",
                        "y": 6
                    }
                ]
            },
            {
                "name": "Reservas",
                "data": [
                    {
                        "x": "00:00",
                        "y": 2
                    },
                    {
                        "x": "01:00",
                        "y": 2
                    },
                    {
                        "x": "02:00",
                        "y": 2
                    },
                    {
                        "x": "03:00",
                        "y": 2
                    },
                    {
                        "x": "04:00",
                        "y": 2
                    },
                    {
                        "x": "05:00",
                        "y": 2
                    },
                    {
                        "x": "06:00",
                        "y": 2
                    },
                    {
                        "x": "07:00",
                        "y": 2
                    },
                    {
                        "x": "08:00",
                        "y": 3
                    },
                    {
                        "x": "09:00",
                        "y": 3
                    },
                    {
                        "x": "10:00",
                        "y": 4
                    },
                    {
                        "x": "11:00",
                        "y": 5
                    },
                    {
                        "x": "12:00",
                        "y": 3
                    },
                    {
                        "x": "13:00",
                        "y": 1
                    },
                    {
                        "x": "14:00",
                        "y": 0
                    },
                    {
                        "x": "15:00",
                        "y": 2
                    },
                    {
                        "x": "16:00",
                        "y": 3
                    },
                    {
                        "x": "17:00",
                        "y": 4
                    },
                    {
                        "x": "18:00",
                        "y": 6
                    },
                    {
                        "x": "19:00",
                        "y": 6
                    },
                    {
                        "x": "20:00",
                        "y": 6
                    },
                    {
                        "x": "21:00",
                        "y": 6
                    },
                    {
                        "x": "22:00",
                        "y": 6
                    },
                    {
                        "x": "23:00",
                        "y": 6
                    }
                ]
            }
        ],
        "categories": [],
        "xAxisType": null,
        "markerSize": 3,
        "unit": "",
        "yAxisLabel": "",
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "disableTotal": false,
        "colors": [
            Theme.color["chart-base-1"],
            Theme.color["chart-base-2"],
            Theme.color["chart-base-3"],
        ]
    },
    "roomReservation": {
        "number": 30,
        "unit": "(55%)",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "checkinsOngoing": {
        "number": 22,
        "unit": "",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "realOccupationBottom": {
        "number": 22,
        "unit": "",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    }
};

export const confortDA = {
    "averageTemperature": {
        "number": 13,
        "unit": "ºC",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "idealTemperature": {
        "number": 25,
        "unit": "ºC",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "averageIdealTemperature": {
        "series": [
            {
                "name": "Temperatura Estimada",
                "data": [
                    {
                        "x": "00:00",
                        "y": 22
                    },
                    {
                        "x": "01:00",
                        "y": 22
                    },
                    {
                        "x": "02:00",
                        "y": 22
                    },
                    {
                        "x": "03:00",
                        "y": 22
                    },
                    {
                        "x": "04:00",
                        "y": 22
                    },
                    {
                        "x": "05:00",
                        "y": 22
                    },
                    {
                        "x": "06:00",
                        "y": 22
                    },
                    {
                        "x": "07:00",
                        "y": 22
                    },
                    {
                        "x": "08:00",
                        "y": 22
                    },
                    {
                        "x": "09:00",
                        "y": 22
                    },
                    {
                        "x": "10:00",
                        "y": 22
                    },
                    {
                        "x": "11:00",
                        "y": 22
                    },
                    {
                        "x": "12:00",
                        "y": 22
                    },
                    {
                        "x": "13:00",
                        "y": 22
                    },
                    {
                        "x": "14:00",
                        "y": 22
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 22
                    },
                    {
                        "x": "17:00",
                        "y": 22
                    },
                    {
                        "x": "18:00",
                        "y": 22
                    },
                    {
                        "x": "19:00",
                        "y": 22
                    },
                    {
                        "x": "20:00",
                        "y": 22
                    },
                    {
                        "x": "21:00",
                        "y": 22
                    },
                    {
                        "x": "22:00",
                        "y": 22
                    },
                    {
                        "x": "23:00",
                        "y": 22
                    },
                    {
                        "x": "24:00",
                        "y": 22
                    }
                ]
            },
            {
                "name": "Temperatura Real",
                "data": [
                    {
                        "x": "00:00",
                        "y": 20
                    },
                    {
                        "x": "01:00",
                        "y": 24
                    },
                    {
                        "x": "02:00",
                        "y": 23
                    },
                    {
                        "x": "03:00",
                        "y": 19
                    },
                    {
                        "x": "04:00",
                        "y": 19
                    },
                    {
                        "x": "05:00",
                        "y": 22
                    },
                    {
                        "x": "06:00",
                        "y": 20
                    },
                    {
                        "x": "07:00",
                        "y": 21
                    },
                    {
                        "x": "08:00",
                        "y": 21
                    },
                    {
                        "x": "09:00",
                        "y": 20
                    },
                    {
                        "x": "10:00",
                        "y": 24
                    },
                    {
                        "x": "11:00",
                        "y": 23
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 24
                    },
                    {
                        "x": "14:00",
                        "y": 22
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 21
                    },
                    {
                        "x": "17:00",
                        "y": 20
                    },
                    {
                        "x": "18:00",
                        "y": 24
                    },
                    {
                        "x": "19:00",
                        "y": 22
                    },
                    {
                        "x": "20:00",
                        "y": 22
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 19
                    },
                    {
                        "x": "23:00",
                        "y": 19
                    },
                    {
                        "x": "24:00",
                        "y": 20
                    }
                ]
            }
        ],
        "categories": null,
        "xAxisType": "number",
        "markerSize": 3,
        "columnWidth": 20,
        "colors": [
            "chart-dark-1",
            "chart-dark-13"
        ]
    }
};

export const confortHistoric = {
    "averageTemperatureChart": {
        "series": [
            {
                "name": "Website Blog",
                "type": "scatter",
                "data": [
                    0,
                    0.3,
                    0.2,
                    0.13,
                    0.199,
                    0.6,
                    0.5,
                    352000,
                    752000,
                    320000,
                    257000,
                    160
                ]
            },
            {
                "name": "Social Media",
                "type": "line",
                "data": [
                    0.5,
                    42000,
                    35000,
                    1.3,
                    43000,
                    22000,
                    17000,
                    31000,
                    22000,
                    22000,
                    12000,
                    16
                ]
            }
        ],
        "categories": null,
        "xAxisType": "datetime",
        "labelFormat": "dd/MM",
        "tooltip": "dd/MM/yyyy",
        "markerSize": 3,
        "unit": "kW",
        "columnWidth": 20,
        "colors": [
            "chart-light-13",
            "chart-light-12"
        ],
        "labels": [
            "01 Jan 2001",
            "02 Jan 2001",
            "03 Jan 2001",
            "04 Jan 2001",
            "05 Jan 2001",
            "06 Jan 2001",
            "07 Jan 2001",
            "08 Jan 2001",
            "09 Jan 2001",
            "10 Jan 2001",
            "11 Jan 2001",
            "12 Jan 2001"
        ],
        "markersSize": [
            6,
            6
        ]
    },
    "averageTemperature": {
        "number": 15,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "averageIdealTemperature": {
        "number": 13,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "map": {
        "series": [
            {
                "name": "Series 1",
                "data": [
                    80,
                    50,
                    30,
                    40,
                    100,
                    20
                ]
            },
            {
                "name": "Series 2",
                "data": [
                    20,
                    30,
                    40,
                    80,
                    20,
                    80
                ]
            },
            {
                "name": "Series 3",
                "data": [
                    44,
                    76,
                    78,
                    13,
                    43,
                    10
                ]
            }
        ],
        "options": {
            "chart": {
                "height": 350,
                "type": "radar",
                "dropShadow": {
                    "enabled": true,
                    "blur": 1,
                    "left": 1,
                    "top": 1
                }
            },
            "title": {
                "text": "Radar Chart - Multi Series"
            },
            "stroke": {
                "width": 2
            },
            "fill": {
                "opacity": 0.1
            },
            "markers": {
                "size": 0
            },
            "yaxis": {
                "stepSize": 20
            },
            "xaxis": {
                "categories": [
                    "2011",
                    "2012",
                    "2013",
                    "2014",
                    "2015",
                    "2016"
                ]
            }
        }
    }
};

export const energyDa = {
    "averageEnergyCosnumption": {
        "number": 15,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "energyConsumptionByUser": {
        "number": 15,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "energyConsumptionByFloor": {
        "series": [
            {
                "name": 2024,
                "data": [
                    {
                        "x": "00:00",
                        "y": 25
                    },
                    {
                        "x": "01:00",
                        "y": 21
                    },
                    {
                        "x": "02:00",
                        "y": 22
                    },
                    {
                        "x": "03:00",
                        "y": 25
                    },
                    {
                        "x": "04:00",
                        "y": 22
                    },
                    {
                        "x": "05:00",
                        "y": 28
                    },
                    {
                        "x": "06:00",
                        "y": 25
                    },
                    {
                        "x": "07:00",
                        "y": 25
                    },
                    {
                        "x": "08:00",
                        "y": 25
                    },
                    {
                        "x": "09:00",
                        "y": 26
                    },
                    {
                        "x": "10:00",
                        "y": 23
                    },
                    {
                        "x": "11:00",
                        "y": 25
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 24
                    },
                    {
                        "x": "14:00",
                        "y": 24
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 20
                    },
                    {
                        "x": "17:00",
                        "y": 24
                    },
                    {
                        "x": "18:00",
                        "y": 22
                    },
                    {
                        "x": "19:00",
                        "y": 19
                    },
                    {
                        "x": "20:00",
                        "y": 22
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 25
                    },
                    {
                        "x": "23:00",
                        "y": 22
                    }
                ]
            }
        ],
        "categories": [],
        "xAxisType": null,
        "labelFormat": null,
        "tooltip": null,
        "unit": "kVArh",
        "columnWidth": 20,
        "xAxisLabel": null,
        "yAxisLabel": "kVArh",
        "color": null,
        "formatterType": null,
        "tickAmount": 12,
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "showTooltipTitle": true
    },
    "evolutionOfBuildingEnergyConsumption": {
        "series": [
            {
                "name": t("Energy Consumption"),
                "type": "column",
                "data": [
                    {
                        "x": "00:00",
                        "y": 30
                    },
                    {
                        "x": "01:00",
                        "y": 24
                    },
                    {
                        "x": "02:00",
                        "y": 25
                    },
                    {
                        "x": "03:00",
                        "y": 21
                    },
                    {
                        "x": "04:00",
                        "y": 21
                    },
                    {
                        "x": "05:00",
                        "y": 31
                    },
                    {
                        "x": "06:00",
                        "y": 23
                    },
                    {
                        "x": "07:00",
                        "y": 21
                    },
                    {
                        "x": "08:00",
                        "y": 22
                    },
                    {
                        "x": "09:00",
                        "y": 21
                    },
                    {
                        "x": "10:00",
                        "y": 27
                    },
                    {
                        "x": "11:00",
                        "y": 23
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 26
                    },
                    {
                        "x": "14:00",
                        "y": 21
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 22
                    },
                    {
                        "x": "17:00",
                        "y": 24
                    },
                    {
                        "x": "18:00",
                        "y": 21
                    },
                    {
                        "x": "19:00",
                        "y": 25
                    },
                    {
                        "x": "20:00",
                        "y": 24
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 26
                    },
                    {
                        "x": "23:00",
                        "y": 26
                    }
                ]
            },
            {
                "name": t("Average Consumption for Homologated Period"),
                "type": "line",
                "data": [
                    {
                        "x": "00:00",
                        "y": 30
                    },
                    {
                        "x": "01:00",
                        "y": 24
                    },
                    {
                        "x": "02:00",
                        "y": 25
                    },
                    {
                        "x": "03:00",
                        "y": 21
                    },
                    {
                        "x": "04:00",
                        "y": 21
                    },
                    {
                        "x": "05:00",
                        "y": 31
                    },
                    {
                        "x": "06:00",
                        "y": 23
                    },
                    {
                        "x": "07:00",
                        "y": 21
                    },
                    {
                        "x": "08:00",
                        "y": 22
                    },
                    {
                        "x": "09:00",
                        "y": 21
                    },
                    {
                        "x": "10:00",
                        "y": 27
                    },
                    {
                        "x": "11:00",
                        "y": 23
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 26
                    },
                    {
                        "x": "14:00",
                        "y": 21
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 22
                    },
                    {
                        "x": "17:00",
                        "y": 24
                    },
                    {
                        "x": "18:00",
                        "y": 21
                    },
                    {
                        "x": "19:00",
                        "y": 25
                    },
                    {
                        "x": "20:00",
                        "y": 24
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 26
                    },
                    {
                        "x": "23:00",
                        "y": 26
                    }
                ]
            }
        ],
        "categories": [],
        "xAxisType": null,
        "labelFormat": "Monthly",
        "tooltip": null,
        "unit": "kW",
        "columnWidth": 20,
        "xAxisLabel": null,
        "yAxisLabel": "kW",
        "color": null,
        "tickAmount": 24,
        "formatterType": "Monthly",
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "showTooltipTitle": true
    }
};

export const datePeriodsDropdown = [
    {
        "value": "Últimos 7 dias",
        "label": "Últimos 7 dias"
    },
    {
        "value": "Último mês",
        "label": "Último mês"
    },
    {
        "value": "Último ano",
        "label": "Último ano"
    }
];

export const energyHistoric = {
    "evolutionOfFloorEnergyConsumption": {
        "series": [
            {
                "name": t("Energy Consumption"),
                "type": "column",
                "data": [
                    {
                        "x": "00:00",
                        "y": 30
                    },
                    {
                        "x": "01:00",
                        "y": 24
                    },
                    {
                        "x": "02:00",
                        "y": 25
                    },
                    {
                        "x": "03:00",
                        "y": 21
                    },
                    {
                        "x": "04:00",
                        "y": 21
                    },
                    {
                        "x": "05:00",
                        "y": 31
                    },
                    {
                        "x": "06:00",
                        "y": 23
                    },
                    {
                        "x": "07:00",
                        "y": 21
                    },
                    {
                        "x": "08:00",
                        "y": 22
                    },
                    {
                        "x": "09:00",
                        "y": 21
                    },
                    {
                        "x": "10:00",
                        "y": 27
                    },
                    {
                        "x": "11:00",
                        "y": 23
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 26
                    },
                    {
                        "x": "14:00",
                        "y": 21
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 22
                    },
                    {
                        "x": "17:00",
                        "y": 24
                    },
                    {
                        "x": "18:00",
                        "y": 21
                    },
                    {
                        "x": "19:00",
                        "y": 25
                    },
                    {
                        "x": "20:00",
                        "y": 24
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 26
                    },
                    {
                        "x": "23:00",
                        "y": 26
                    }
                ]
            },
            {
                "name": t("Average Consumption for Homologated Period"),
                "type": "line",
                "data": [
                    {
                        "x": "00:00",
                        "y": 30
                    },
                    {
                        "x": "01:00",
                        "y": 24
                    },
                    {
                        "x": "02:00",
                        "y": 25
                    },
                    {
                        "x": "03:00",
                        "y": 21
                    },
                    {
                        "x": "04:00",
                        "y": 21
                    },
                    {
                        "x": "05:00",
                        "y": 31
                    },
                    {
                        "x": "06:00",
                        "y": 23
                    },
                    {
                        "x": "07:00",
                        "y": 21
                    },
                    {
                        "x": "08:00",
                        "y": 22
                    },
                    {
                        "x": "09:00",
                        "y": 21
                    },
                    {
                        "x": "10:00",
                        "y": 27
                    },
                    {
                        "x": "11:00",
                        "y": 23
                    },
                    {
                        "x": "12:00",
                        "y": 25
                    },
                    {
                        "x": "13:00",
                        "y": 26
                    },
                    {
                        "x": "14:00",
                        "y": 21
                    },
                    {
                        "x": "15:00",
                        "y": 22
                    },
                    {
                        "x": "16:00",
                        "y": 22
                    },
                    {
                        "x": "17:00",
                        "y": 24
                    },
                    {
                        "x": "18:00",
                        "y": 21
                    },
                    {
                        "x": "19:00",
                        "y": 25
                    },
                    {
                        "x": "20:00",
                        "y": 24
                    },
                    {
                        "x": "21:00",
                        "y": 21
                    },
                    {
                        "x": "22:00",
                        "y": 26
                    },
                    {
                        "x": "23:00",
                        "y": 26
                    }
                ]
            }
        ],
        "categories": null,
        "xAxisType": null,
        "labelFormat": "dd/MM",
        "tooltip": "dd/MM/yyyy",
        "markerSize": 3,
        "unit": "kW",
        "columnWidth": 20,
        "colors": [
            '#E6EFCC',
            '#CCECE0'
        ],
        "markersSize": [
            6,
            6
        ]
    },
    "averageEnergyConsumption": {
        "number": 15,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "energyConsumptionPerUser": {
        "number": 13,
        "unit": "kWh",
        "type": null,
        "label": null,
        "fluctuation": null,
        "fluctuationText": null,
        "bigFluctuation": false,
        "icon": null
    },
    "peakOfTheMonth": [
        {
            "number": 13,
            "unit": t("Day"),
            "type": null,
            "label": null,
            "fluctuation": null,
            "fluctuationText": null,
            "bigFluctuation": false,
            "icon": null
        },
        {
            "number": 13,
            "unit": "kWh",
            "type": null,
            "label": null,
            "fluctuation": null,
            "fluctuationText": null,
            "bigFluctuation": false,
            "icon": null
        }
    ],
    "consumptionPerFloor": {
        "series": [
            {
                "name": t("Floor") + " 1",
                "value": 21
            },
            {
                "name": t("Floor") + " 2",
                "value": 23
            },
            {
                "name": t("Floor") +  " 3",
                "value": 16
            },
            {
                "name": t("Floor") + " 4",
                "value": 13
            },
            {
                "name": t("Floor") + " 5",
                "value": 10
            },
            {
                "name": t("Floor") + " 6",
                "value": 17
            }
        ],
        "categories": null,
        "tooltip": null,
        "markerSize": 3,
        "unit": "ui",
        "columnWidth": 20,
        "filename": "Gráfico exportado",
        "headerValue": "valores",
        "headerCategory": "categorias",
        "total": " ",
        "disableTotal": true,
        "sideLegend": true,
        "dataLabelsOffset": 40,
        "customScale": 0.9
    }
};